
export default function AICapability() {
  const aiCapabilities = [
    {
      icon: 'ri-brain-line',
      title: '商品归类辅助识别',
      desc: '基于商品描述与历史数据，提供HS编码建议',
    },
    {
      icon: 'ri-search-eye-line',
      title: '数据异常模式识别',
      desc: '自动识别数据中的异常模式与潜在风险点',
    },
    {
      icon: 'ri-lightbulb-line',
      title: '字段智能提示',
      desc: '根据上下文提供字段填写建议与补全',
    },
  ];

  const ruleCapabilities = [
    {
      icon: 'ri-shield-check-line',
      title: '提交前逻辑校验',
      desc: '基于规则引擎进行多维度逻辑一致性检查',
    },
    {
      icon: 'ri-error-warning-line',
      title: '差异自动标记',
      desc: '自动标记数据源之间的差异与不一致',
    },
    {
      icon: 'ri-links-line',
      title: '链路一致性判断',
      desc: '确保业务链路各环节数据关系的完整性',
    },
  ];

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="text-4xl font-bold text-gray-900 text-center mb-16">
          AI与规则引擎协同机制
        </h2>

        <div className="grid lg:grid-cols-2 gap-10">
          <div className="space-y-4">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-1 h-8 bg-gradient-to-b from-[#0D9488] to-[#14B8A6] rounded-full"></div>
              <h3 className="text-xl font-bold text-gray-800">AI能力</h3>
            </div>
            {aiCapabilities.map((item, index) => (
              <div
                key={index}
                className="p-5 rounded-xl border border-gray-100 bg-[#F0FDFA] hover:border-[#14B8A6]/50 hover:shadow-sm transition-all"
              >
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#14B8A6]/15 text-[#14B8A6] flex-shrink-0">
                    <i className={`${item.icon} text-lg`}></i>
                  </div>
                  <div>
                    <h4 className="text-base font-semibold text-gray-800 mb-1">{item.title}</h4>
                    <p className="text-sm text-gray-500">{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="space-y-4">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-1 h-8 bg-gradient-to-b from-[#FF6B35] to-[#FF8C42] rounded-full"></div>
              <h3 className="text-xl font-bold text-gray-800">规则能力</h3>
            </div>
            {ruleCapabilities.map((item, index) => (
              <div
                key={index}
                className="p-5 rounded-xl border border-gray-100 bg-[#FFF7ED] hover:border-orange-300 hover:shadow-sm transition-all"
              >
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#FF6B35]/10 text-[#FF6B35] flex-shrink-0">
                    <i className={`${item.icon} text-lg`}></i>
                  </div>
                  <div>
                    <h4 className="text-base font-semibold text-gray-800 mb-1">{item.title}</h4>
                    <p className="text-sm text-gray-500">{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 p-6 rounded-xl border border-[#14B8A6]/20 bg-gradient-to-r from-[#F0FDFA] to-[#FFF7ED] text-center">
          <p className="text-gray-600 text-base">
            AI用于提高识别与提示能力，
            <span className="mx-2 text-gray-300">|</span>
            规则系统确保业务逻辑稳定性。
          </p>
        </div>
      </div>
    </section>
  );
}
